import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSizeById } from "../../../api/sizeService";
import { getErrorMessage } from "../../../utils/errorHandler";

export default function ViewSize() {
  const location = useLocation();
  const id = location?.state?.sizeId;

  const [size, setSize] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSize = async () => {
    try {
      setLoading(true);

      const response = await getSizeById(id);

      setSize(response?.data || response);
    } catch (error) {
      console.error("Error fetching size:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchSize();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Loading...
          </div>
        </div>
      </div>
    );
  }

  if (!size) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Size not found
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
        <div className="card p-3 d-flex justify-content-between">
          

          <div className="row g-3">
            <div className="col-md-4">
              <span className="fw-bold">Size Name : </span>
              
                {size.name || "N/A"}
            
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Size Value : </span>
                {size.value || "N/A"}
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Status : </span>
                <span
                  className={`badge ${
                    size.status ? "bg-success" : "bg-danger"
                  }`}
                >
                  {size.status ? "Active" : "Inactive"}
                </span>
            </div>
          </div>
        </div>
    </div>
  );
}